import dayjs from "dayjs";
import {
  Cells
} from "../constants";

export const UsersColumn = [
  {
    key: "name",
    header: "Name",
    className: "text-primary font-medium",
    cell: Cells.USER_AVATAR_NAME,
  },
  { key: "loginName", header: "Login Name", responsive: ["lg"], className: "font-medium" },
  { key: "email", header: "Email", responsive: ["lg"], className: "font-medium" },
  { key: "mobileNo", header: "Mobile No.", responsive: ["lg"], className: "font-medium" },
  { key: "country", header: "Country", responsive: ["lg"], className: "font-medium" },
  { key: "language", header: "Language", responsive: ["lg"], className: "font-medium" },
  { key: "role", header: "Role", responsive: ["lg"], className: "font-medium" },
  { key: "isActive", header: "Active?", responsive: ["lg"], className: "font-medium", fn: (value: any) => (value ? "Yes" : "No") },
];

export const CompanyUsersColumn = [
  {
    key: "name",
    header: "Name",
    className: "text-primary font-medium",
    cell: Cells.USER_AVATAR_NAME,
  },
  { key: "loginName", header: "Login Name", responsive: ["md", "lg"], className: "font-medium" },
  { key: "email", header: "Email", responsive: ["md", "lg"], className: "font-medium" },
  { key: "mobileNo", header: "Mobile No.", responsive: ["md", "lg"], className: "font-medium" },
  { key: "roleName", header: "Role", responsive: ["md", "lg"], className: "font-medium" },
  { key: "isActive", header: "Active?", responsive: ["md", "lg"], className: "font-medium", fn: (value: any) => (value ? "Yes" : "No") },
];

export const ChartOfAccountsColumn = [
  { key: "accountNo", header: "Account No.", className: "text-primary font-medium" },
  { key: "accountTitle", header: "Account Title", className: "text-primary font-medium" },
  { key: "parentAccount", header: "Parent", responsive: ["lg"], className: "font-medium", fn: (value: any, record: any) => record.parentAccount?.accountTitle },
  { key: "ledgerType", header: "Ledger Type", responsive: ["lg"], className: "font-medium", fn: (value: any, record: any) => record.ledgerType?.name },
  { key: "openingBalance", header: "Opening Balance", responsive: ["lg"], className: "font-medium", align: "right", fn: (value: any, record: any) => (record.isGroup ? "-" : value.toFixed(2)) },
  { key: "currentBalance", header: "Current Balance", responsive: ["lg"], className: "font-medium", align: "right", fn: (value: any, record: any) => (record.isGroup ? "-" : value.toFixed(2)) },
];

export const ModulesColumn = [
  {
    key: "name",
    header: "Name",
    className: "text-primary font-medium"
  },
  { key: "route", header: "Route", responsive: ["lg"], className: "font-medium" },
  { key: "createdDate", header: "Created On", responsive: ["lg"], className: "font-medium", fn: (value: any) => dayjs(value)?.format("DD MMM, YYYY") },
];

export const CompaniesColumn = [
  {
    key: "name",
    header: "Name",
    className: "text-primary font-medium",
    cell: Cells.COMPANY_CELL,
  },
  { key: "addressLine1", header: "Address Line1", responsive: ["lg"], className: "font-medium" },
  { key: "addressLine2", header: "Address Line2", responsive: ["lg"], className: "font-medium" },
  { key: "email", header: "Email", responsive: ["lg"], className: "font-medium" },
  { key: "phone", header: "Phone", responsive: ["lg"], className: "font-medium" },
  { key: "isActive", header: "Active", responsive: ["lg"], className: "font-medium", fn: (value: any) => (value ? "Yes" : "No") },
];

export const SubscriptionsColumn = [
  {
    key: "module",
    header: "Module",
    className: "text-primary font-medium",
    fn: (value: any, record: any, index: number) => record?.module?.name
  },
  {
    key: "company",
    header: "Company",
    className: "text-primary font-medium",
    fn: (value: any, record: any, index: number) => record?.company?.name
  },
  { key: "createdDate", header: "Created On", responsive: ["lg"], className: "font-medium", fn: (value: any) => dayjs(value)?.format("DD MMM, YYYY") },
  { key: "status", header: "Status", responsive: ["lg"], className: "font-medium" },
  { key: "statusDate", header: "Status Date", responsive: ["lg"], className: "font-medium", fn: (value: any) => dayjs(value)?.format("DD MMM, YYYY") }
];

export const LocationsColumn = [
  {
    key: "name",
    header: "Name",
    className: "text-primary font-medium"
  },
  { key: "type", header: "Type", className: "font-medium" },
  { key: "parentId", header: "Parent", className: "font-medium", fn: (value: any, record: any) => record?.parent?.name  },
  { key: "createdTime", header: "Created On", responsive: ["lg"], className: "font-medium", fn: (value: any) => dayjs(value)?.format("DD MMM, YYYY") },
];

export const DataSourcesColumn = [
  {
    key: "displayName",
    header: "Display Name",
    className: "text-primary font-medium"
  },
  {
    key: "name",
    header: "Name",
    responsive: ["lg"],
    className: "font-medium"
  },
  { key: "type", header: "Type", className: "font-medium", responsive: ["lg"], fn: (value: any) => value === "Text" ? "List of Text" : value === "Object" ? "List of Object" : value },
  { key: "data", header: "Items", className: "font-medium", responsive: ["lg"], cell: Cells.LENGTH_COUNT }
];

export const CountryColumn = (pageNo: number, pageSize: number) => [
  {
    key: "index",
    header: "#",
    className: "font-medium",
    width: 20,
    render: (value: any, item: any, index: number) => (pageNo - 1) * pageSize + index + 1
  },
  {
    key: "name",
    header: "Name",
    className: "text-primary font-medium",
    width: 300
  },
  {
    key: "description",
    header: "Description",
    className: "font-medium",
    responsive: ["lg"],
    width: 300
  },
  {
    key: "code",
    header: "Code",
    className: "font-medium",
    width: 100,
    responsive: ["lg"]
  },
  { key: "dialCode", header: "Dial Code", className: "font-medium", responsive: ["lg"] },
  { key: "isActive", header: "Status", className: "font-medium", fn: (value: any) => value === true ? "Active" : "Inactive" }
];